// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ev-info-card_cardContainer__nPp7V","iconTitleContainer":"ev-info-card_iconTitleContainer__uln8a","text":"ev-info-card_text__sU7u2"};